mutateQuery